module.exports = __webpack_public_path__ + "static/img/widget-box.58603de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/widget-box.png
// module id = 5X1h
// module chunks = 1